export default __webpack_public_path__ + "static/media/foto_07.04ba76ad.jpg";